module.exports = __webpack_public_path__ + "img/human_1.dbb90917.png";